export enum MetalsTaskType {
    Laser = "laser",
    PressBrake = "press brake",
    PEMs = "pems",
    Fabricating = "fabricating",
    PowderCoating = "powder coating",
    Stamping = "stamping",
    Deburring = "deburring",
    ToolRoom = "tool room",
    TurretPunch = "turret punch",
    RollForming = "roll forming",
    Assembly = "assembly",
    Packaging = "packing",
    DrillPress = "drill press",
    OutsideProcessing = "outside processing",
    Transfer = "transfer"
}